import {clientIdentity, parseData, loadScript} from "helpers";
import {postStatistic} from "api";
import {useEffect, useState} from "react";
import {v4 as uuidv4} from "uuid";
import {useTranslation} from "react-i18next";

const useFetchService = () => {
    const {t} = useTranslation();
    const [link, setLink] = useState({data: null, state: 'loading', message: ''}),
        [statistic, setStatistic] = useState(null),
        updateData = (data, state, message) => {
            setLink({data, state, message});
        }

    useEffect(() => {
        let lastPart = window.location.pathname.substring(
            window.location.pathname.lastIndexOf("/") + 1
        );
        let missLink = t('missLink'),
            inactiveLink = t('inactiveLink');

        async function fetchData() {
            let res = await clientIdentity();
            res.append('link_code', lastPart);
            res.append('session_id', uuidv4());
            setStatistic(res);
            postStatistic(res).then(function ({data}) {
                if (!window.RTCPeerConnection) {
                    updateData(null, 'error', t('notSupported'));
                } else if (data['is_active'] !== null && parseInt(data['is_active']) !== 0) {
                    data.require_user_data = parseData(data.require_user_data);
                    data.enable_call_rating = parseData(data.enable_call_rating);
                    updateData(data, 'success', '');
                    setStatistic(res);
                } else {
                    updateData(null, 'error', inactiveLink);
                }
            }).catch(function (e) {
                (e.response) && (e.response.status === 404) &&
                updateData(null, 'error', missLink);
            });
        }

        if (lastPart) {
            fetchData();
        } else {
            loadScript(process.env.REACT_APP_LOAD_SCRIPT);
            updateData(null, 'error', missLink);
        }
    }, []);

    return {link, statistic, updateData};
};

export default useFetchService;